__turbopack_context__.v({
  "code": "P7jHDq_code",
  "docs": "P7jHDq_docs",
  "emphasis": "P7jHDq_emphasis",
  "h1": "P7jHDq_h1",
  "h2": "P7jHDq_h2",
  "h3": "P7jHDq_h3",
  "h4": "P7jHDq_h4",
  "h5": "P7jHDq_h5",
  "h6": "P7jHDq_h6",
  "imgTitle": "P7jHDq_imgTitle",
  "noMargin": "P7jHDq_noMargin",
  "p": "P7jHDq_p",
  "small": "P7jHDq_small",
});
